import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=793be265&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793be265')) {
      api.createRecord('793be265', component.options)
    } else {
      api.reload('793be265', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=793be265&", function () {
      api.rerender('793be265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W1a4VvzX4oh2/JS/offershelp.vue"
export default component.exports